import { render } from "./ForbiddenView.vue?vue&type=template&id=0f38c7f9&scoped=true"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=0f38c7f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f38c7f9"]])

export default __exports__